import type { Theme } from '@livecontrol/core-ui';
import { createContext } from 'react';

export const Context = createContext<{ setTheme: (name: Theme.Name) => void }>({
  setTheme() {
    // eslint-disable-next-line no-console
    console.error('No ThemeProvider found. Theme context should be a descendant of ThemeProvider.');
  }
});
